"use strict";

/*
 * Cart widget for mainmenu
 */

(function ($) {
  // ECMA5 strict mode
  'use strict';

  // check namespace
  $.b2b = $.b2b || {};
  var Widget = function Widget() {
    var me = this;
    var options = {
      $el: null,
      $list: null,
      $label: null,
      $openCart: null,
      cart: null,
      itemsCount: 0,
      sumRub: null,
      sumUsd: null
    };
    this.updating = false;
    this.updating_callback = null; // функция, которую надо запустить после загрузки

    var items = []; //список товаров корзины
    var consolidationSet = null; //список наборов оборудования    
    var maxCount = 5;
    this.init = function () {
      options.$el = $('#cart-widget');
      options.$list = options.$el.find('#cart-widget__list');
      options.$label = options.$el.find('#cart-widget__label');
      options.$openCart = options.$el.find('#cart-widget__openCart');
      options.$el.on("mouseover", function () {
        $.b2b.MainMenuWidgets.open("#cart-widget");
      }).on("mouseleave", function () {
        $.b2b.MainMenuWidgets.closeWidget();
      });
      options.$el.data('widget', me);
    };

    // получение списка из корзины с сервера
    this.update = function (disableRefresh) {
      if ($(document).find("#cart-widget").length > 0) {
        me.updating = true;
        $.b2b.ajax({
          url: '/Cart/GetDataForWidget',
          success: function success(data) {
            me.updating = false;
            options.cart = data.cart;
            options.itemsCount = data.itemsCount;
            options.sumRub = data.priceRub;
            options.sumUsd = data.priceUsd;
            items = options.cart.Items;
            if (options.cart.ConsolidationSets.length > 0) consolidationSet = options.cart.ConsolidationSets[0];
            if (disableRefresh !== true) {
              me.refresh();
            }
            if (me.updating_callback) {
              me.updating_callback.call(me);
            }
          },
          error: function error(jqXHR) {
            me.updating = false;
            $.b2b.errors.showAjaxError(jqXHR);
          }
        });
      }
    };
    this.refresh = function () {
      if (options.$el.length > 0) {
        if (this.updating) {
          // еще идет загрузка с сервера
          this.updating_callback = function () {
            me.refresh();
          };
        }
        if (options.itemsCount > 0) {
          options.$label.html(options.itemsCount);
          options.$el.find('#cartWidgetSumUsd').html(options.sumUsd);
          options.$el.find('#cartWidgetSumRub').html(options.sumRub);
        } else {
          options.$openCart.addClass("hidden");
          options.$el.find('#cartWidgetSumUsd').html(0);
          options.$el.find('#cartWidgetSumRub').html(0);
        }
        var $table = $('<table/>');
        if (items.length > 0) {
          $table.append('<tr ><td><b>Артикул</b></td><td><b>Кол-во</b></td><td><b>Стоимость</b></td></tr>');
          // собираем список товаров                    
          for (var i = 0; i < items.length; i++) {
            var tr = $('<tr/>');
            var product = items[i];
            tr.append($('<td>' + product.Articul + '</td>'));
            var qty = product.Qty;
            if (product.ProductMultiplicity > 1 && product.ProductMeasure != null && product.ProductMeasure != '') {
              qty += ' ' + product.ProductMeasure;
            }
            tr.append($('<td>' + qty + '</td>'));
            if (product.UsdPrice != null && product.UsdPrice > 0) {
              var usdsum = product.UsdPrice * product.Qty;
              tr.append($('<td>' + formatNumber(usdsum, 2, ',', ' ') + ' <i class="fa fa-usd"></i>' + '</td>'));
            } else if (product.RubPrice != null && product.RubPrice > 0) {
              var rubsum = product.RubPrice * product.Qty;
              ;
              tr.append($('<td>' + formatNumber(rubsum, 2, ',', ' ') + ' <i class="fa fa-rub"></i>' + '</td>'));
            } else tr.append($('<td>Уточните у менеджера</td>'));
            $table.append(tr);
            if (i === maxCount - 1) break;
          }
          //список из первого набора оборудования                              
        }
        if (consolidationSet != null && items.length < maxCount) {
          var trTop = $('<tr class="consolidateSetHeader"> <td>' + consolidationSet.Source + '</td> <td/><td/> </tr>');
          $table.append(trTop);
          for (var i = 0; i < consolidationSet.Products.length; i++) {
            var product = consolidationSet.Products[i];
            var tr = $('<tr class="consolidateSet"/>');
            tr.append($('<td>' + product.Articul + '</td>'));
            tr.append($('<td>' + product.Qty + ' шт.' + '</td>'));
            var cur = '';
            var num = product.Price * product.Qty;
            if (product.CurrencyCode === 1) cur = ' <i class="fa fa-usd"></i>';else if (product.CurrencyCode === 18) cur = ' <i class="fa fa-rub"></i>';
            tr.append($('<td>' + formatNumber(num, 2, ',', ' ') + cur + '</td>'));
            $table.append(tr);
          }
        }
        options.$list.empty();
        if ($table !== null) {
          options.$list.append($table);
        }
      }
    };
  };
  function formatNumber(floatValue, c, d, t) {
    //<summary>Форматирование вещественного числа.</summary>
    // <param name="floatValue" type="Float">Число</param>
    // <param name="с" type="Float">Кол-во знаков после запятой</param>
    // <param name="d" type="String">Разделитель целов и вещественной части</param>
    // <param name="t" type="String">Разделитель разрядов, наппример для "'" 12348 -> 12'348</param>

    //метод взят из бэклога, наименование переменных сохранено

    c = isNaN(c = Math.abs(c)) ? 2 : c;
    d = d == undefined ? "," : d;
    t = t == undefined ? "." : t;
    var n = floatValue,
      s = n < 0 ? "-" : "",
      i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
      j = (j = i.length) > 3 ? j % 3 : 0;
    return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
  }
  ;

  // Запускаем сразу, но отрисуется тогда, когда DOM построен
  var instance = new Widget();
  instance.update(true);
  $(document).ready(function () {
    instance.init();
    instance.refresh();
  });
})(jQuery);